<template>
  <dashboard-container>
    <dashboard-section>
      <div class="w-full" v-if="currentProject">
        <FormulateForm
          @submit="updateProject"
          :values="currentProject"
          class="max-w-screen-xs"
        >
          <label class="text-sm text-gray-500 leading-8" for="name"
            >Project name...</label
          >
          <base-input
            autofocus
            required
            placeholder="Type name of project..."
            id="name"
            name="name"
            class="mb-6"
          />

          <label class="text-sm text-gray-500 leading-8"
            >Is this project active?</label
          >

          <label
            class="text-sm text-gray-500 leading-8 block flex items-center mb-6"
          >
            <FormulateInput
              name="active"
              type="checkbox"
              input-class="form-checkbox w-4 h-4 text-primary transition duration-150 ease-in-out mr-2"
            />
            Active
          </label>

          <div class="mb-6 max-w-screen-sm w-full border border-gray-300 dark:border-gray-600 rounded-lg p-4 flex flex-col items-start">

                  <span class="text-sm text-gray-500 dark:text-gray-600">Current plan</span>
                  <typography variant="p" class="font-semibold capitalize text-gray-700 dark:text-gray-300">{{ currentProject.billing.plan }}</typography>

                  <span class="text-sm text-gray-500 dark:text-gray-600 mt-6">Billed models</span>
                  <typography variant="p" class="font-semibold capitalize text-gray-700 dark:text-gray-300">{{ deployedModels.length }}</typography>

                  <span class="text-sm text-gray-500 dark:text-gray-600 mt-6">Monthly cost</span>
                  <typography variant="p" class="font-semibold capitalize text-gray-700 dark:text-gray-300">${{ monthlyProjectCost }}</typography>

                  <button
                    @click="openBillingPortal"
                    title="Open Billing Settings"
                    aria-label="Open Billing Settings"
                    class="underline focus:outline-none text-primary hover:text-primary-400 focus:shadow-outline hover:opacity-75 transition duration-150 mt-4"
                    type="submit"
                  >
                    Open Billing Settings
                  </button>

          </div>

          <base-button bgColor="bg-success dark:bg-green-600" borderColor="border-success" hoverBg="hover:bg-green-400 dark-hover:bg-green-500" hoverBorder="hover:border-success-400" class="mt-10" icon="settings" iconPosition="left"   type="submit">Save Changes</base-button>
          
        </FormulateForm>


      </div>
    </dashboard-section>
  </dashboard-container>
</template>

<script>
import { LayoutComponents } from "@/modules/Dashboard/components";
import StatBox from "@/core-components/StatBox";
import { updateProject, updateAuthenticationState } from "@/graphql/mutations";
import monthlyPricing from "@/data/monthly-pricing";

import {
  currentProject,
  loading,
  error,
  authenticationState,
  myProjects,
  billing,
} from "@/mixins";

export default {
  name: "ProjectSettings",
  metaInfo: {
      title: 'Project Settings',
  },
  mixins: [
    LayoutComponents,
    authenticationState,
    loading,
    error,
    currentProject,
    myProjects,
    billing,
  ],
  data() {
    return {
      isSubmitting: false,
      monthlyModelPrice: monthlyPricing['MODEL']
    };
  },
  methods: {
    async updateProject(data) {
      if (this.isSubmitting) {
        return;
      }

      this.isSubmitting = true;

      try {
        this.$root.$emit("loading", true);

        await this.$apollo.mutate({
          mutation: updateProject,
          variables: {
            input: {
              projectId: this.authenticationState.selectedProject,
              name: data.name,
              active: data.active,
            },
          },
        });

        if (!data.active) {
          await this.$apollo.mutate({
            mutation: updateAuthenticationState,
            variables: {
              selectedProject: this.myProjects[0].id,
            },
          });
          
          this.$router.push({ name: "Project" });
        }
      } catch (error) {
        this.handleError(error);
      }

      this.$root.$emit("loading", false);

      this.isSubmitting = false;
    },
  },
  computed: {
    monthlyProjectCost(){
      return this.monthlyModelPrice * this.deployedModels.length;
    }
  }
};
</script>
